package br.com.vvrefeicoes.portal.feature.auth.forgotPassword

import org.jetbrains.compose.resources.StringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.auth_password_rule_lowercase
import portalvv.shared.generated.resources.auth_password_rule_min_length
import portalvv.shared.generated.resources.auth_password_rule_no_spaces
import portalvv.shared.generated.resources.auth_password_rule_number
import portalvv.shared.generated.resources.auth_password_rule_uppercase

enum class PasswordRule(
    val label: StringResource,
    private val isSatisfied: (String) -> Boolean,
) {
    MinLength(
        label = Res.string.auth_password_rule_min_length,
        isSatisfied = { it.length >= 8 },
    ),
    Uppercase(
        label = Res.string.auth_password_rule_uppercase,
        isSatisfied = { it.any(Char::isUpperCase) },
    ),
    Lowercase(
        label = Res.string.auth_password_rule_lowercase,
        isSatisfied = { it.any(Char::isLowerCase) },
    ),
    Number(
        label = Res.string.auth_password_rule_number,
        isSatisfied = { it.any(Char::isDigit) },
    ),
    NoSpaces(
        label = Res.string.auth_password_rule_no_spaces,
        isSatisfied = { it.none(Char::isWhitespace) },
    ),
    ;

    fun isSatisfiedBy(password: String): Boolean = isSatisfied(password)

    companion object {
        fun allSatisfiedBy(password: String): Boolean = entries.all { it.isSatisfiedBy(password) }
    }
}
